<span class="example">
<div [innerText]="data"></div>
</span>
